"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.A = {
    "prof standards in agribusiness": 1,
    "equine science": 1,
    "livestock production": 1,
    "small animal management": 1,
    "vet medical applications": 1,
    "advanced animal science": 1,
    "food processing": 1,
    "agricultural power sys": 1,
    /* new courses added 2018-06-26 */
    "advanced environmental tech": 1,
    "advanced floral design": 1,
    "ag fac desgn & fabr": 1,
    "intro to process technology": 1,
    "oil and gas production i": 1,
    "oil and gas production ii": 1,
    "oil and gas production iii": 1,
    "petrochem sfty, hlth & environ": 1,
    "practcm in ag,food&nat res ii": 1,
    "principles of oil & gas prdctn": 1,
    "princpl of ag, food, & nat res": 1,
    "viticulture": 1,
    "adv energy & natrl resrce tech": 1,
    "pctm ag,food,nat resrc 2nd tme": 2,
    "agrcltr structure design & fab": 1,
    "ag eqpmnt dsgn&fab/lab&fld exp": 2,
    "ag strc dsgn&fab/ag lab&fld ex": 1,
    "agbz mgt & mkt/agr lab&fld exp": 2,
    "agr mech&mtl tch/ag lab&fld ex": 2,
    "agri leadership research & com": 1,
    "agricul pwr sys/ag lab&fld exp": 3,
    "agricultural equipmnt dsgn&fab": 1,
    "comp tch prac/ext prc": 1,
    "comp techn practicum": 1,
    "floral design/agri lab&fld exp": 2,
    "food processng/agr lab&fld exp": 2,
    "food tech&sfty/agr lab&fld exp": 2,
    "grnhs opr&pdctn/ag lab&fld exp": 2,
    "horticultrl sci/ag lab&fld exp": 2,
    "lvstock prd/agr lab & fld expr": 2,
    "nrg&nat rs tch/agr lab&fld exp": 2,
    "oil&gas prod i/agr lab&fld exp": 2,
    "prc/ext pr ag,food,nat rs": 1,
    "prct animation 2nd time taken": 2,
    "range ecol&mgt/ag lab&fld exp": 2,
    "turf grass management": 0.5,
    "vet med apps/agr lab & fld exp": 2,
    "wldl,fsh&eco mgt/ag lb&fld exp": 2,
};
exports.B = {
    "practicum in constr mgt": 1,
    "practicum in archtect design": 1,
    "practicum in inter design": 1,
    /* new courses added 2018-06-26 */
    "adv architectural design": 1,
    "adv building maint tech": 1,
    "adv electrical technology": 1,
    "adv piping & plumbing tech": 1,
    "advan interior design": 1,
    "advanced constr technology": 1,
    "architectural design": 1,
    "practicum in archtect desgn ii": 1,
    "practicum in constr mgt ii": 1,
    "practicum in inter design ii": 1,
    "plumbing technology ii": 2,
    "building maintenance tech ii": 2,
    "pctm interior design": 1,
    "prctcm construction mgt 2nd tm": 2,
    "interior design ii": 2,
    "prctcm construction mgt 1st tm": 1,
    "construction technology ii": 1,
    "prctm architecture dsgn 1st tm": 2,
    "prctm architecture dsgn 2nd tm": 2,
    "architectural design i": 1,
    "electrical technology ii": 1,
    "pipefitting technology i": 1,
    "prct const tech 1st time taken": 1,
    "prct/ext prct arc dsgn 2nd tme": 3,
    "prct/ext prct cons mgt 1st tme": 3,
    "prct/ext prct cons tch 1st tme": 3,
    "prct/ext prct cons tch 2nd tme": 3,
    "principles of architecture": 1,
    "principles of construction": 1,
};
exports.C = {
    "professional communications": 1,
    "practicum fashion design": 1,
    /* new courses added 2018-06-26 */
    "adv audio video production": 1,
    "adv fashion design": 1,
    "adv print & imaging tech": 1,
    "practic graph dsgn & illust ii": 1,
    "practicum audio video prod ii": 1,
    "practicum graph desgn & illust": 1,
    "princ arts/aud vid tech & comm": 1,
    "print & imaging tech": 1,
    "radio broadcasting i": 1,
    "radio broadcasting ii": 1,
    "video game design ii": 1,
    "video game design iii": 1,
    "practicum in fashn dsgn 1st tm": 2,
    "practicum aud/vid prod 2nd tme": 2,
    "audio/video production ii": 1,
    "video game programming": 1,
    "prctm grph dsgn & ilust 2nd tm": 2,
    "prnc arts, aud/vid tech & comm": 1,
    "fashion design ii": 1,
    "prctm grph dsgn & ilust 1st tm": 2,
    "printing & imaging technolgy i": 1,
    "printing & imaging technlgy ii": 1,
    "advancd video game programming": 1,
    "animation i/animation i lab": 2,
    "animation ii/animation ii lab": 2,
    "aud/vid prductn1/prductn1 lab": 2,
    "aud/vid prductn2/prductn2 lab": 2,
    "commercl photog 2/photog 2 lab": 2,
    "commercl photog i/photog i lab": 2,
    "fashion dsgn 2/fash dsgn 2 lab": 2,
    "fashion dsgn i/fash dsgn i lab": 2,
    "grph dsg&il1/grph dsg&il1 lab": 2,
    "grph dsg&il2/grph dsg&il2 lab": 2,
    "prct animation 1st time taken": 2,
    "prct in comercl photog 1st tme": 2,
    "prct/ext prct animatn 1st time": 3,
    "prct/ext prct arc dsgn 1st tme": 3,
    "prct/ext prct au/vd prd 1st tm": 3,
    "prct/ext prct au/vd prd 2nd tm": 3,
    "prct/ext prct fash dsgn 1st tm": 3,
    "prct/ext prct grph dsgn&il 1st": 3,
    "prct/ext prct prnt&img tch 1st": 3,
    "print & imag tech i/tech i lab": 2,
    "print&imag tech ii/tech ii lab": 2,
    "video game design": 1,
};
exports.D = {
    "touch sys data entry": 1,
    "business law": 1,
    "business english": 1,
    "busin info mgt i": 1,
    "busin info mgt ii": 1,
    "business management": 1,
    "global business": 1,
    "virtual business": 1,
    "human resources mgt": 1,
    "practicum business mgt": 1,
    /* new courses added 2018-06-26 */
    "ib business & mgt i": 1,
    "ib business & mgt ii": 1,
    "ib economics higher level": 2,
    "practicum business mgt ii": 1,
    "princ of busin, mark, & finan": 1,
    "practicum in busin mgt 2nd tme": 2,
    "practicum in busin mgt 1st tme": 2,
    "business info mgt i/biz lab": 2,
    "business info mgt ii/biz lab": 2,
    "fundamentals of real estate": 2,
    "prac/ext prct bus mgt": 1,
};
exports.E = {
    "princ of ed & training": 1,
    "human growth & develop": 1,
    "instr pract in ed & training": 2,
    "practicum ed & training": 2,
    "practicum ed & training ii": 1,
    "instructional practices": 2,
    "prctm in eductn & trng 1st tme": 2,
    "prctm in eductn & trng 2nd tme": 2,
    "enginer apps of comp sci prncp": 1,
    "prac/ext prac edu&trn": 1
};
exports.F = {
    "money matters": 1,
    "securities and investments": 1,
    "insurance operations": 1,
    "banking & financ svcs": 1,
    "accounting i": 1,
    "accounting ii": 1,
    "financial analysis": 1,
    /* new courses added 2018-06-26 */
    "stat & risk mgt": 1,
    "stat & busness decision making": 1
};
exports.G = {
    "princ gov & public admin": 1,
    "political science i": 1,
    "political science ii": 1,
    "foreign svc & diplomacy": 1,
    "planning & governance": 1,
    "national security": 1,
    "public mgt & admin": 1,
    "revenue, tax, & regulation": 1,
    /* new courses added 2018-06-26 */
    "practicm local,st& fed gov ii": 1,
    "prctm local,st&fed govt 2nd tm": 2,
    "health science theory/clinical": 2,
    "math for medical professionals": 1,
    "prct/ext prct hlth science 1st": 3,
    "prct/ext prct hlth science 2nd": 3 //credit edit 2024
};
exports.H = {
    "principles of health science": 1,
    "medical terminology": 1,
    "anatomy & physiology": 1,
    "medical microbiology": 1,
    "world health research": 1,
    pathophysiology: 1,
    "practicum health science": 1,
    /* new courses added 2018-06-26 */
    "biomedical innovation": 1,
    "dosage calculations": 1,
    "human body systems": 1,
    "mathematics for medical pros": 1,
    "medical biotechnology": 1,
    "medical interventions": 1,
    "practicum health science ii": 1,
    "princpls of biomed science": 1,
    "speech & language development": 1,
    "prctm in hlth science 2nd time": 2,
    "prctm in hlth science 1st time": 2 //credit edit 2024
};
exports.I = {
    "princ of hospit & toursim": 1,
    "culinary arts": 2,
    "advanced culinary arts": 1,
    "food science": 1,
    "pracitcum culinary arts": 1,
    "travel & tourism mgt": 1,
    "hotel management": 1,
    "hospitality services": 1,
    "practicum hospit srvcs": 1,
    /* new courses added 2018-06-26 */
    "baking and pastry arts": 1,
    "baking and pastry arts lab": 1,
    "pracitcum culinary arts ii": 1,
    "practicum hospit srvcs ii": 1,
    "restaurant management": 1,
    "prctm in hspitalty svcs 2nd tm": 2,
    "prctum in culinary arts 2nd tm": 2,
    "prctum in culinary arts 1st tm": 2,
    "prctm in hspitalty svcs 1st tm": 2,
    "introduction to culinary arts": 1,
    "prct/ext prct culn arts 1st tm": 3,
    "prct/ext prct culn arts 2nd tm": 3,
    "prct/ext prct hosplty svcs 1st": 3,
    "prct/ext prct hosplty svcs 2nd": 3,
};
exports.J = {
    "principles of human svcs": 1,
    "dollars and sense": 1,
    "lifetime nutrit & wellnss": 1,
    "interpersonal studies": 1,
    "counsel & mental health": 1,
    "child development": 1,
    "child guidance": 1,
    "family & comm svcs": 1,
    "practicum human svcs": 1,
    "intr to cosmetology": 1,
    "cosmetology i": 1,
    "cosmetology ii": 1,
    /* new courses added 2018-06-26 */
    "barbering i": 3,
    "cosmetlgy facial spec": 1,
    "cosmetlgy manicure spec": 1,
    "cosmetlgy sham & cond spec": 1,
    "hair braiding specialist": 1,
    "parent ed f/schl age prnts i": 1,
    "parent ed f/schl age prnts ii": 1,
    "princ of cos dsgn & clr theory": 1,
    "nail care, enhncemnts &spa svc": 2,
    "esthetics": 2,
    "practicum in human svcs 1st tm": 2,
    "parenting education ii": 1,
    "parenting education i": 1,
    "cosmetology i/cosmetolgy i lab": 3,
    "cosmetology i/cosmetlgy ii lab": 3,
    "greenhouse operation & prductn": 1,
    "micr biolgy & sfy fr cos crers": 1,
    "prac/ext prc humn svc": 1,
    "prin cosmtl desgn&color theory": 1,
};
exports.K = {
    "principles of info tech": 1,
    "computer maintenance": 1,
    "web technologies": 1,
    "correctional services": 1,
    /* new courses added 2018-06-26 */
    "database fundamental": 1,
    "database programming": 1,
    "geographic info sys": 1,
    "ib info tech-globl soc hgh lvl": 2,
    "ib info tech-globl soc std lvl": 2,
    "internetworking tech i": 1,
    "internetworking tech ii": 1,
    "principles of cyber security": 1,
    "raster based geo info sys": 1,
    "research in info tech sol ii": 1,
    "research in info tech sol": 1,
    "telecomm & networking": 1,
    "prctum info technology 2nd tme": 2,
    "prctum info technology 1st tme": 2,
    "networking": 1,
    "computer maintenance/main lab": 2,
    "networking/networking lab": 2,
    "prac/ext prc info tch": 1,
    "principles of cybersecurity": 1,
    "ind study in tech aps 2nd time": 1,
};
exports.L = {
    "firefighter i": 1,
    "firefighter ii": 1,
    "law enforcement i": 1,
    "law enforcement ii": 1,
    "forensic science": 1,
    "court sys & practices": 1,
    /* new courses added 2018-06-26 */
    "disaster response": 1,
    "emergency med technician-basic": 2,
    "forensic psychology": 1,
    "introduction to american law": 1,
    "legal research and writing": 1,
    "prctm law/pub saf/crct/&sec ii": 1,
    "princ law, pub safe,corrt &sec": 1,
    "security services": 1,
    "prc law,pubsft,cor&sfty 2nd tm": 2,
    "fed law enfrcemnt&protect svcs": 1,
    "prc/ext law,pubsf,cor,sec": 1
};
exports.M = {
    "principles of manufacturing": 1,
    "practicum manufacturing": 1,
    "fashion marketing": 1,
    entrepreneurship: 1,
    "social media marketing": 1,
    /* new courses added 2018-06-26 */
    "adv flexible manufacturing": 1,
    "adv precision metal manuf": 1,
    "flexible manufacturing": 1,
    "manufacturing engineering": 1,
    "occuptnl sfty & environ tech i": 1,
    "occuptnl sfty &environ tech ii": 1,
    "practicum manufacturing ii": 1,
    "metal fbrication, machining ii": 2,
    "metal fbrication & machining i": 2,
    "prctm in manufacturing 2nd tme": 2,
    "precision metal mnufacturng ii": 2,
    "prctm in manufacturing 1st tme": 1,
    "mnfg engineering technology i": 1,
    "manu engineering technology ii": 1,
    "prac/ext prac manufac": 1,
    "precis mtl manu ii/mnfg ii lab": 3,
    "welding ii/welding ii lab": 3,
};
exports.N = {
    /* new courses added 2018-06-26 */
    "advertising & sales promo": 1,
    "marketing dynamics": 1,
    "practicum marketin dynamics ii": 1,
    "practicum marketing dynamics": 1,
    "retailing & e-tailing": 1,
    "practicum in marketing 1st tme": 2,
    "advanced marketing": 1,
    "advertising": 1,
    "practicum in marketing 2nd tme": 2,
    "prac/ext prc mrketing": 1,
    "retail management": 1,
};
exports.O = {
    "principles of technology": 1,
    "digital electronics": 1,
    "eng design & prob solving": 1,
    "engineering mathematics": 1,
    "scientific research & design": 1,
    /* new courses added 2018-06-26 */
    "adv eng design & presentation": 1,
    "advanced electronics": 1,
    "aerospace engineering": 1,
    "biotechnology engineer": 1,
    "civil eng & architectur": 1,
    "comp integrated manuf": 1,
    "computer scince & sftwre engin": 1,
    "concepts of eng & tech": 1,
    "data acquisition & analysis": 1,
    "dc dircuits": 1,
    "digital fundamentals": 1,
    "digital image processing": 1,
    "electronics": 1,
    "eng design & develop": 1,
    "eng design & presentation": 1,
    "eng: the digit futr": 1,
    "gateway to technology i": 1,
    "gateway to technology ii": 1,
    "gateway to technology iii": 1,
    "intro to engin design": 1,
    "practcm science/tech/eng/&math": 1,
    "practm scinc/tech/eng/&math ii": 1,
    "principles of engineering": 1,
    "robotics and automation": 1,
    "scientific research & desgn ii": 1,
    "tx prefreshman eng pgm iii": 1,
    "tx prefreshman eng pgm iv": 1,
    "engineering science": 1,
    "engineering dsgn & presentn ii": 2,
    "envronmntl sustainabilty pltw)": 1,
    "robotics": 1,
    "gateway to tech": 1,
    "principles of appld enginering": 1,
    "solid state electronics": 1,
    "ac/dc electronics": 1,
    "prct sci,tech eng&math 2nd tme": 2,
    "engineering dsgn & presentn i": 1,
    "prct sci,tech eng&math 1st tme": 2,
    "biotechnology ii": 1,
    "intro comp aided dsgn&drafting": 1,
    "pct/ext pct sci-tch-en-mth 1st": 3 //credit edit 2024
};
exports.P = {
    /* new courses added 2018-06-26 */
    "adv aircraft technology": 1,
    "adv automotive technology": 1,
    "adv collis repair & refinish": 1,
    "adv small engine technology": 1,
    "advanced shipboard engineering": 1,
    "automotive technology": 1,
    "intro to shipboard engineering": 1,
    "logist, plan & mgt sys": 1,
    "maritime science i": 1,
    "maritime science ii": 1,
    "practicum trans, dist & log": 1,
    "practicum trans, dist & log ii": 1,
    "principles of maritime science": 1,
    "distribution and logistics": 1,
    "auto technology ii: auto servc": 2,
    "paint and refinishing": 1,
    "auto tech i: mnt & lght repair": 2,
    "small engine technology ii": 1,
    "aircraft powerplant technology": 1,
    "aircr airfrm tch/adv tr sys lb": 3,
    "basic col repair & refinishing": 1,
    "coll repair/adv trans syst lab": 3,
    "intro to aircraft technology": 1,
    "intro to transport technology": 0.5,
    "prac/ext prac trns sys 1st tme": 3,
    "prac/ext prac trns sys 2nd tme": 3,
    "prac/ext prc distr&logstcs 1st": 3,
    "pract dstr & logistics 1st tme": 2,
    "pract in trns systems": 1,
    "prnciples of distrb & lgistics": 1,
    "prnciples of transport systems": 1,
};
exports.oneTwentySevenB = {
    "career preparation i": 2,
    "career preparation ii": 2,
    /* new courses added 2018-06-26 */
    "applied math for tech profsnls": 1,
    "general employability skills": 1,
    "barbering ii": 3 //credit edit 2024
};
//# sourceMappingURL=chapter130.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/tea_data/chapter130.js
// module id = 206
// module chunks = 22